// Local Imports
import { useDispatch } from 'react-redux';
import { LogoutIcon } from '@/assets/icons/LogoutIcon';
import { logoutFn } from '@/utils';
import { updateEditKit } from '@/redux/features/MediaKit/mediakitSlice';

export const Logout = () => {
  const dispatch = useDispatch();

  return (
    <div className='m-auto h-[90px] md:h-[110px] w-full flex justify-center px-4 py-4 bg-white'>
      <div
        className={`horizontal-center hover:underline decoration-[1px] hover:underline-offset-4 gap-2 cursor-pointer h-full`}
        onClick={async (e) => {
          // TEMP DIAGNOSTIC: confirm whether this fires from a real user click
          // (isTrusted: true) or a script/extension-dispatched event (false).
          console.warn('[Logout] triggered, isTrusted:', e?.isTrusted, e);
          dispatch(updateEditKit(false));
          await logoutFn()
          setTimeout(() => logoutFn(), 100);
        }}
      >
        <p className='text-base font-outfit uppercase'>Logout</p>
        <div className='!rounded-full !border !border-neutral-light4 !p-2'>
          <LogoutIcon />
        </div>
      </div>
    </div>
  );
};
